module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_05_1280_1280_vi-c00f6e80eb2846178a9d51e7909a6563.jpg";